/**
 * Initialize ClipboardJS on elements with .copy-to-clipboard class.
 * Uses the toast action system instead of calling window.toastr directly.
 */
const initClipboard = () => {
    if (typeof ClipboardJS === 'undefined') {
        console.warn('ClipboardJS is not loaded');
        return;
    }

    // Avoid re-initializing
    if (window.Smart._clipboardInitialized) {
        return;
    }

    const clipboard = new ClipboardJS('.copy-to-clipboard');

    clipboard.on('success', function(e) {
        window.Smart.utils.process_actions([{
            name: 'toast',
            data: {
                type: 'success',
                title: window.Smart.lang.clipboard_success_title || 'Success',
                message: window.Smart.lang.clipboard_success_message || 'Copied to clipboard',
            }
        }]);
        e.clearSelection();
    });

    clipboard.on('error', function(e) {
        window.Smart.utils.process_actions([{
            name: 'toast',
            data: {
                type: 'error',
                title: window.Smart.lang.clipboard_error_title || 'Error',
                message: window.Smart.lang.clipboard_error_message || 'Failed to copy',
            }
        }]);
    });

    window.Smart._clipboardInitialized = true;
};

export default initClipboard;
